// Placeholder for type hints; no TypeScript
export const CustomerStage = ['Inquiry', 'PreLeads', 'AI Qualification', 'Trial Arranged', 'Trail Done', 'Sales'];
